import axios from "@/libs/api.request";

// 获取分类列表
export const getClassList = params => {
  return axios.request({
    url: "/document/document_category",
    method: "get",
    params
  });
};
// 新增分类
export const addClass = data => {
  return axios.request({
    url: "/document/document_category",
    method: "post",
    data
  });
};
// 编辑分类
export const editClass = data => {
  return axios.request({
    url: "/document/document_category/" + data.id,
    method: "put",
    data
  });
};
// 删除分类
export const deleteClass = id => {
  return axios.request({
    url: "/document/document_category/" + id,
    method: "delete"
  });
};
